// extracted by mini-css-extract-plugin
export var canBeSelected = "tag-module--can-be-selected--b958a";
export var container = "tag-module--container--99618";
export var notActive = "tag-module--not-active--8486a";